module.exports = __webpack_public_path__ + "static/media/graphing.3f8cf1f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Create/NewResource/images/graphing.png
// module id = 1218
// module chunks = 2